import { createSlice } from '@reduxjs/toolkit';

import type { AdvogadoState } from '@/types/advogado/advogadoTypes';

import {
  atualizarAdvogado,
  buscarAdvogadoPorId,
  criarAdvogado,
  listarAdvogados,
  removerAdvogado,
} from './actions';

const initialState: AdvogadoState = {
  advogados: [],
  currentAdvogado: null,
  total: 0,
  page: 1,
  limit: 20,
  isLoading: false,
  error: null,
};

const advogadoSlice = createSlice({
  name: 'advogado',
  initialState,
  reducers: {
    clearAdvogadoError: (state) => {
      state.error = null;
    },
    clearCurrentAdvogado: (state) => {
      state.currentAdvogado = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listarAdvogados.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(listarAdvogados.fulfilled, (state, action) => {
        state.isLoading = false;
        state.advogados = action.payload.data;
        state.total = action.payload.total;
      })
      .addCase(listarAdvogados.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(buscarAdvogadoPorId.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(buscarAdvogadoPorId.fulfilled, (state, action) => {
        state.isLoading = false;
        state.currentAdvogado = action.payload;
      })
      .addCase(buscarAdvogadoPorId.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(criarAdvogado.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(criarAdvogado.fulfilled, (state, action) => {
        state.isLoading = false;
        state.advogados.unshift(action.payload);
      })
      .addCase(criarAdvogado.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(atualizarAdvogado.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(atualizarAdvogado.fulfilled, (state, action) => {
        state.isLoading = false;
        const index = state.advogados.findIndex((a) => a.id === action.payload.id);
        if (index !== -1) state.advogados[index] = action.payload;
        if (state.currentAdvogado?.id === action.payload.id) state.currentAdvogado = action.payload;
      })
      .addCase(atualizarAdvogado.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(removerAdvogado.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(removerAdvogado.fulfilled, (state, action) => {
        state.isLoading = false;
        state.advogados = state.advogados.filter((a) => a.id !== action.payload);
      })
      .addCase(removerAdvogado.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export default advogadoSlice.reducer;
